import DashboardComp from 'components/Dashboard/DashboardComp'
import { useUser } from 'contexts/UserContext'
import useFetch from 'hooks/useFetch'
import { useEffect } from 'react'

export default function DashboardPage() {
  const { user } = useUser()
  const [fetchedStats, fetchStats] = useFetch()

  useEffect(() => {
    fetchStats({
      url: 'siniestros/dashboard/stats',
      method: 'GET',
      messageKo: 'Error cargando estadísticas'
    })
  }, [])

  return (
    <section className="bg-white h-fit dark:bg-gray-900">
      <div className="container px-6 py-10 mx-auto h-fit">
        <h1 className="text-2xl font-semibold text-gray-800 capitalize lg:text-3xl dark:text-white">
          Bienvenido{' '}
          <span className="underline decoration-[#FCAE52]">
            {user?.first_name + ' ' + user?.last_name}
          </span>
          !
        </h1>

        <DashboardComp stats={fetchedStats} />
      </div>
    </section>
  )
}